import PropTypes from 'prop-types';

import { CtaPropTypes } from '@/constants/propTypes';

import LinkButton from '@/components/common/LinkButton';
import InfoCard from '@/components/common/InfoCardList/InfoCard';
import TitleContainer from '@/components/layout/title/TitleContainer';

import styles from './InfoCardList.module.scss';

export const InfoCardList = ({ data, cta }) => {
  const { contentTitle, espotsList } = data;

  return espotsList && (
    <div className={styles.container}>
      <TitleContainer label={contentTitle}>
        <>
          <div className={styles.list} data-test-id="info-card-list-content">
            {espotsList?.map((item) => (
              <InfoCard
                key={item._id}
                title={{
                  content: item.espot.contentTitle,
                  customClass: styles.contentTitle
                }}
                desc={{
                  content: item.espot.desc,
                  customClass: styles.desc
                }}
                img={{
                  src: item.espot.img,
                  alt: item.espot.alt,
                  width: 64,
                  height: 64,
                }}
                center
                borderColor={cta.background.color}
              />
            ))}
          </div>
          <div className={styles.btn}>
            <LinkButton cta={cta} />
          </div>
        </>
      </TitleContainer>
    </div>
  );
};

InfoCardList.propTypes = {
  data: PropTypes.shape({
    contentTitle: PropTypes.string.isRequired,
    espotsList: PropTypes.array
  }).isRequired,
  cta: PropTypes.shape(CtaPropTypes).isRequired
};

export default InfoCardList;
